import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../contexts/UserContext";
import NotificationPop from "../NotificationPop";
import HTTPSCalls from "../../Services/HttpCalls";
import { toast } from "react-toastify";
import MobileFooter from "../MobileFooter";
import { GoBell } from "react-icons/go";
import logo from "../../assets/Images/start-icon.png";
// echo.js is now initialized lazily via NotificationContext when user logs in
import { NotificationContext } from "../../contexts/NotificationContext";
import { useTranslation } from "react-i18next";
import i18n from 'i18next';
import axios from "axios";
import { DeliveryRequestsContext } from "../../contexts/DeliveryRequestsContext";
import { TiWeatherPartlySunny } from "react-icons/ti";
import { IoPersonOutline } from "react-icons/io5";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { CiStar } from "react-icons/ci";
import { FaRegCopy } from "react-icons/fa";
import { FaSignOutAlt, FaCog } from "react-icons/fa";

// Inline SVG sailboat icon to avoid importing the 14 MB react-icons/gi package
const SailboatIcon = ({ size = 24, ...props }) => (
  <svg viewBox="0 0 512 512" width={size} height={size} fill="currentColor" {...props}>
    <path d="M199.256 74.5v285H27.744l25.998 78H380.255l104-78h-267v-285h-18zm18 18c36.787 88.85 64.94 216 0 250h208c22-34-11.905-164.76-208-250zm-36 0c-33.046 69.333-50 200-144 250h144v-250z" />
  </svg>
);

// ⚡ sweetalert2 loaded on-demand (169KB) — only fires on user interactions
const getSwal = () => import("sweetalert2").then(m => m.default);

const Header = ({ isActive }) => {
  const { t } = useTranslation();
  const isLoggedIn = !!localStorage.getItem("token");
  const location = useLocation();
  // const { user, isLoading } = useContext(UserContext);
  const laravelDomainUrl = process.env.REACT_APP_LARAVEL_DOMAIN_URL;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [url, setUrl] = useState(laravelDomainUrl);
  // const [refreshDelivery, setRefreshDelivery] = useState(false);
  const PERSON_PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11' stroke='%23fff' stroke-width='1.6'/%3E%3Ccircle cx='12' cy='9' r='3' stroke='%23fff' stroke-width='1.6'/%3E%3Cpath d='M5.5 19.5c1-3 3.5-4.5 6.5-4.5s5.5 1.5 6.5 4.5' stroke='%23fff' stroke-width='1.6' stroke-linecap='round'/%3E%3C/svg%3E";

  const { user, subscriptionToggle } = useContext(UserContext);
  // console.log(user);

  // FIXED: Removed empty useEffect that did nothing

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpanded_mv, setIsExpanded_mv] = useState(false);
  const [isNavbarExpanded, setIsNavbarExpanded] = useState(false);
  const [notificationClicked, setNotificationClicked] = useState(false);
  const [isMaintenanceScheduleExpanded, setIsMaintenanceScheduleExpanded] =
    useState(false);
  const [
    isMaintenanceScheduleExpanded_mv,
    setIsMaintenanceScheduleExpanded_mv,
  ] = useState(false);
  const { unreadCount, setUnreadCount, liveNotification, setLiveNotification, resetUnreadCount } = useContext(NotificationContext);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const settingsToggleRef = useRef(null);

  // Navbar click
  const closePanels = () => {
    const panels = [
      document.querySelector(".left-panel"),
      document.querySelector(".right-panel"),
      document.querySelector(".center-panel"),
      document.querySelector(".center-panel-dashboard"),
    ];

    panels.forEach((panel) => {
      if (panel) {
        panel.classList.remove("expand-close", "expand", "shift-center-left");
      }
    });
  };


  useEffect(() => {
    if (user?.language) {
      i18n.changeLanguage(user.language);
    }
  }, [user?.language, i18n]);

  const closeNavbar = () => {
    const navbar = document.querySelector(".navbar-collapse");
    if (navbar && navbar.classList.contains("show")) {
      navbar.classList.remove("show");
      setIsNavbarExpanded(false);
    }
  };

  // Close navbar when any nav-link inside it is clicked (mobile menu items)
useEffect(() => {
  const navbar = document.querySelector(".navbar-collapse");
  if (!navbar) return;

  const handleNavClick = (event) => {
    const link = event.target.closest(".nav-link, .dropdown-item");
    if (link) {
      closeNavbar();
    }
  };

  navbar.addEventListener("click", handleNavClick);
  return () => {
    navbar.removeEventListener("click", handleNavClick);
  };
}, []);

  // leftPanel work starts
  const handleMarineDashboardClick = () => {
    setIsExpanded(!isExpanded);
    setIsNavbarExpanded(false);
  };
  // leftPanel my-vessel work starts
  const handleMVLeftPanelClick = () => {
    setIsExpanded_mv(!isExpanded_mv);
    setIsNavbarExpanded(false);
  };

  // rightPanel work starts
  const handleMaintenanceScheduleClick = () => {
    setIsMaintenanceScheduleExpanded(!isMaintenanceScheduleExpanded);
    setIsNavbarExpanded(false);
  };
  // rightPanel my-vessel work starts
  const handleMVRightClick = () => {
    setIsMaintenanceScheduleExpanded_mv(!isMaintenanceScheduleExpanded_mv);
    setIsNavbarExpanded(false);
  };

  // Request browser notification permission and handle live notification side-effects
  useEffect(() => {
    if (!user) return;
    if ("Notification" in window) {
      if (Notification.permission === "default") {
        Notification.requestPermission().then((permission) => {
          if (permission !== "granted") {
            console.warn("User denied notification permission");
          }
        });
      }
    }

    const handleLive = (evt) => {
      const e = evt?.detail || evt;
      try {
        if (e.type === "account_suspension" || e.type === "account_block") {
          navigate("/logout");
        }
        if (e.type === "delivery_request_cancelled") {
          if (location.pathname !== "/portfolio") {
            navigate("/portfolio");
          }
        }
        if ("Notification" in window && Notification.permission === "granted") {
          new Notification(
            e.title || t('header.notification.defaultTitle', 'Notification'),
            {
              body: e.message,
              data: {
                type: e.type,
                link: e.link,
                title: e.title || t('header.notification.defaultTitle', 'Notification'),
              },
              icon: logo,
              requireInteraction: false,
            }
          );
        }
      } catch (err) {
        console.log("Notification API unavailable in this environment", err);
      }
    };

    window.addEventListener("app:live-notification", handleLive);
    return () => window.removeEventListener("app:live-notification", handleLive);
  }, [user]);

  useEffect(() => {
    // Ensure navbar is closed on initial load
    if (document && document.readyState === "complete") {
      const navbar = document.querySelector(".navbar-collapse");
      if (navbar) {
        navbar.classList.remove("show");
      }
    }
  }, []);

  useEffect(() => {
    // Check user status and logout if suspended/blocked
    if (user?.status === "suspended" || user?.status === "blocked") {
      localStorage.removeItem("token");
      navigate("/logout");
    }
  }, [user?.status, navigate]); // FIXED: Added proper dependencies

  //For portfolio page left slide
  const isExpandedInitial = useRef(true);
  useEffect(() => {
    const leftPanel = document.querySelector(".left-panel");
    const centerPanel = document.querySelector(".center-panel-dashboard");
    const rightPanel = document.querySelector(".right-panel");
    const navbar = document.querySelector(".navbar-collapse");

    // Handle Navbar
    if (navbar) {
      if (isNavbarExpanded) {
        navbar.classList.add("show");
      } else {
        navbar.classList.remove("show");
      }
    }

    // Skip left panel toggle on initial render to prevent auto-opening on mobile
    if (isExpandedInitial.current) {
      isExpandedInitial.current = false;
      return;
    }

    // Handle Left Panel
    if (leftPanel) {
      const isLeftExpanded = leftPanel.classList.contains("expand");
      if (!isLeftExpanded) {
        leftPanel.classList.add("expand");
        leftPanel.classList.remove("expand-close");
        if (centerPanel) centerPanel.classList.add("shift-center-left");
      } else {
        leftPanel.classList.remove("expand");
        if (centerPanel) centerPanel.classList.remove("shift-center-left");
      }
    }

    // Handle Right Panel
    if (rightPanel) {
      if (isExpanded) {
        rightPanel.classList.add("expand-close");
      } else {
        rightPanel.classList.remove("expand-close");
      }
    }
  }, [isExpanded, isNavbarExpanded]);

  // Close navbar when clicking outside
  // useEffect(() => {
  //   const handleOutsideClick = (event) => {
  //     const navbar = document.querySelector(".navbar-collapse");
  //     const navbarToggler = document.querySelector(".navbar-toggler");

  //     // Only proceed if navbar is open
  //     if (!navbar || !navbar.classList.contains("show")) return;

  //     // Check if click is outside navbar and toggler
  //     if (
  //       !navbar.contains(event.target) &&
  //       !navbarToggler?.contains(event.target)
  //     ) {
  //       closeNavbar();
  //     }
  //   };

  //   document.addEventListener("click", handleOutsideClick);

  //   return () => {
  //     document.removeEventListener("click", handleOutsideClick);
  //   };
  // }, []);

  useEffect(() => {
    // Collapse mobile navbar on route change
    const navbar = document.querySelector(".navbar-collapse");
    if (navbar && navbar.classList.contains("show")) {
      navbar.classList.remove("show");
      setIsNavbarExpanded(false); // update your state too
    }
  }, [location.pathname]);

  //For my-vessel page left slide
  const isMvExpandedInitial = useRef(true);
  useEffect(() => {
    const mv_leftPanel = document.querySelector(
      ".MyVessel-container .left-panel"
    );
    const mv_centerPanel = document.querySelector(
      ".MyVessel-container .center-panel"
    );
    const mv_rightPanel = document.querySelector(
      ".MyVessel-container .right-panel"
    );
    const navbar = document.querySelector(".navbar-collapse");

    // Handle Navbar
    if (navbar) {
      if (isNavbarExpanded) {
        navbar.classList.add("show");
      } else {
        navbar.classList.remove("show");
      }
    }

    // Skip left panel toggle on initial render to prevent auto-opening on mobile
    if (isMvExpandedInitial.current) {
      isMvExpandedInitial.current = false;
      return;
    }

    // Handle Left Panel
    if (mv_leftPanel) {
      const isLeftExpanded = mv_leftPanel.classList.contains("expand");
      if (!isLeftExpanded) {
        mv_leftPanel.classList.add("expand");
        mv_leftPanel.classList.remove("expand-close");
        if (mv_centerPanel) mv_centerPanel.classList.add("shift-center-left");
      } else {
        mv_leftPanel.classList.remove("expand");
        if (mv_centerPanel)
          mv_centerPanel.classList.remove("shift-center-left");
      }
    }

    // Handle Right Panel
    if (mv_rightPanel) {
      if (isExpanded) {
        mv_rightPanel.classList.add("expand-close");
      } else {
        mv_rightPanel.classList.remove("expand-close");
      }
    }
  }, [isExpanded_mv, isNavbarExpanded]);

  //For portfolio page right slide
  useEffect(() => {
    const leftPanel = document.querySelector(".left-panel");
    const centerPanel = document.querySelector(".center-panel-dashboard");
    const rightPanel = document.querySelector(".right-panel");
    const navbar = document.querySelector(".navbar-collapse");

    // Handle Navbar
    if (navbar) {
      if (isNavbarExpanded) {
        navbar.classList.add("show");
      } else {
        navbar.classList.remove("show");
      }
    }

    // Handle Right Panel
    if (rightPanel) {
      const isRightExpanded = rightPanel.classList.contains("expand");
      if (!isRightExpanded) {
        rightPanel.classList.add("expand");
        rightPanel.classList.remove("expand-close");
        if (centerPanel) centerPanel.classList.add("shift-center-left");
      } else {
        rightPanel.classList.remove("expand");
        if (centerPanel) centerPanel.classList.remove("shift-center-left");
      }
    }

    // Handle Left Panel
    if (leftPanel) {
      if (isMaintenanceScheduleExpanded) {
        leftPanel.classList.add("expand-close");
      } else {
        leftPanel.classList.remove("expand-close");
      }
    }
  }, [isMaintenanceScheduleExpanded, isNavbarExpanded]);

  //For my-vessel page right slide
  useEffect(() => {
    const mvr_leftPanel = document.querySelector(".left-panel");
    const mvr_centerPanel = document.querySelector(".center-panel");
    const mvr_rightPanel = document.querySelector(".right-panel");
    const navbar = document.querySelector(".navbar-collapse");

    // Handle Navbar
    if (navbar) {
      if (isNavbarExpanded) {
        navbar.classList.add("show");
      } else {
        navbar.classList.remove("show");
      }
    }

    // Handle Right Panel
    if (mvr_rightPanel) {
      const isRightExpanded = mvr_rightPanel.classList.contains("expand");
      if (!isRightExpanded) {
        mvr_rightPanel.classList.add("expand");
        mvr_rightPanel.classList.remove("expand-close");
        if (mvr_centerPanel) mvr_centerPanel.classList.add("shift-center-left");
      } else {
        mvr_rightPanel.classList.remove("expand");
        if (mvr_centerPanel)
          mvr_centerPanel.classList.remove("shift-center-left");
      }
    }

    // Handle Left Panel
    if (mvr_leftPanel) {
      if (isMaintenanceScheduleExpanded_mv) {
        mvr_leftPanel.classList.add("expand-close");
      } else {
        mvr_leftPanel.classList.remove("expand-close");
      }
    }
  }, [isMaintenanceScheduleExpanded_mv, isNavbarExpanded]);





  const handleClick = (event) => {
    try {
      if (Notification.permission === "default") {
        Notification.requestPermission().then((permission) => {
          if (permission !== "granted") {
            console.warn("❌ User denied notification permission");
          }
        });
      }
    } catch (err) {
      console.log("ℹ️ Notifications are not supported in this environment", err);
    }

    setShow(!show);
    setTarget(event.target);
    setNotificationClicked(true);
    // Count stays until notifications are actually marked as read
  };

  // When header is clicked anywhere, lower ewallet header z-index so overlays can appear above it
  const handleHeaderClick = () => {
    try {
      const ew = document.querySelector('.ewallet-header');
      if (ew) {
        ew.style.zIndex = '0';
      }
    } catch (err) {
      // ignore
    }
  };



  //   const handleInvite = async () => {
  //   try {
  //     let reactappurl = process.env.REACT_APP_DOMAIN_URL;
  //     let referralCode = user?.my_referral_code;

  //     // Generate referral code if missing
  //     if (!referralCode) {
  //       const token = localStorage.getItem("token");

  //       const response = await axios.post(
  //         `${apiUrl}/user/referral/generate`,
  //         {},
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );

  //       referralCode = response.data?.referral?.my_referral_code;
  //     }

  //     if (!referralCode) {
  //       toast.error("Unable to generate referral code.");
  //       return;
  //     }

  //     const referralLink = `${reactappurl}signup?ref_code=${referralCode}`;

  //     // Use Web Share API on mobile (works great on Safari/iOS)
  //     if (navigator.share) {
  //       try {
  //         await navigator.share({
  //           title: 'Join me on Vesseli!',
  //           text: 'Use my referral link to sign up:',
  //           url: referralLink,
  //         });
  //         return;
  //       } catch (shareError) {
  //         // User cancelled or share failed, fall through to clipboard
  //         if (shareError.name === 'AbortError') {
  //           return; // User cancelled, don't show error
  //         }
  //       }
  //     }

  //     // Desktop or share API not available - try clipboard
  //     let copied = false;

  //     if (navigator.clipboard && window.isSecureContext) {
  //       try {
  //         await navigator.clipboard.writeText(referralLink);
  //         copied = true;
  //       } catch (e) {
  //         copied = fallbackCopyText(referralLink);
  //       }
  //     } else {
  //       copied = fallbackCopyText(referralLink);
  //     }

  //     if (copied) {
  //       toast.success("Referral link copied to clipboard!");
  //     } else {
  //       // Final fallback - show link for manual copy
  //       toast.info(
  //         <div>
  //           <p>Your referral link:</p>
  //           <p style={{ wordBreak: 'break-all', fontSize: '12px', marginTop: '4px' }}>
  //             {referralLink}
  //           </p>
  //         </div>,
  //         { autoClose: false }
  //       );
  //     }

  //   } catch (error) {
  //     console.error("Referral error:", error);
  //     toast.error("Failed to generate referral link.");
  //   }
  // };

  // const fallbackCopyText = (text) => {
  //   const textarea = document.createElement("textarea");
  //   textarea.value = text;
  //   textarea.contentEditable = true;
  //   textarea.readOnly = false;
  //   textarea.style.position = "fixed";
  //   textarea.style.left = "0";
  //   textarea.style.top = "0";
  //   textarea.style.width = "2em";
  //   textarea.style.height = "2em";
  //   textarea.style.padding = "0";
  //   textarea.style.border = "none";
  //   textarea.style.outline = "none";
  //   textarea.style.boxShadow = "none";
  //   textarea.style.background = "transparent";
  //   textarea.style.opacity = "0";

  //   document.body.appendChild(textarea);

  //   // iOS Safari specific handling
  //   const range = document.createRange();
  //   range.selectNodeContents(textarea);

  //   const selection = window.getSelection();
  //   selection.removeAllRanges();
  //   selection.addRange(range);

  //   textarea.setSelectionRange(0, 999999);

  //   let success = false;
  //   try {
  //     success = document.execCommand("copy");
  //   } catch (err) {
  //     console.error("Fallback copy failed:", err);
  //   }

  //   selection.removeAllRanges();
  //   document.body.removeChild(textarea);

  //   return success;
  // };

  const handleInvite = async () => {
    try {
      let reactappurl = process.env.REACT_APP_DOMAIN_URL;
      let referralCode = user?.my_referral_code;

      // Generate referral code if missing
      if (!referralCode) {
        let token = null;

        // Safe localStorage access (for private browsing)
        try {
          token = localStorage.getItem("token");
        } catch (e) {
          console.error("localStorage not available:", e);
        }

        if (!token) {
          toast.error("Please log in again.");
          return;
        }

        try {
          const response = await axios.post(
            `${apiUrl}/user/referral/generate`,
            {},
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              timeout: 10000, // 10 second timeout
            }
          );

          referralCode = response.data?.referral?.my_referral_code;

          // Update user state if you have a setter
          // setUser(prev => ({ ...prev, my_referral_code: referralCode }));

        } catch (apiError) {
          console.error("API Error:", apiError);
          console.error("Status:", apiError.response?.status);
          console.error("Data:", apiError.response?.data);

          const errorMessage = apiError.response?.data?.message
            || apiError.message
            || "Failed to generate referral code.";
          toast.error(errorMessage);
          return;
        }
      }

      if (!referralCode) {
        toast.error("Unable to generate referral code.");
        return;
      }

      const referralLink = `${reactappurl}signup?ref_code=${referralCode}`;

      // Try Flutter channel first (for Android/iOS WebView in Flutter app)
      if (window.flutter_inappwebview) {
        try {
          await window.flutter_inappwebview.callHandler("shareLink", referralLink);
          return;
        } catch (e) {
          console.error("Flutter share failed:", e);
        }
      }

      // Use Web Share API (works on mobile browsers and iOS WebView)
      if (navigator.share) {
        try {
          await navigator.share({
            title: "Join me on Vesseli!",
            text: "Sign up using my referral link:",
            url: referralLink,
          });
          return;
        } catch (shareError) {
          if (shareError.name === "AbortError") {
            return;
          }
          console.error("Share failed:", shareError);
          // Fall through to clipboard
        }
      }

      // Desktop or share API not available - try clipboard
      const copied = await copyToClipboard(referralLink);

      if (copied) {
        toast.success("Referral link copied to clipboard!");
      } else {
        // Final fallback - show link for manual copy
        toast.info(
          <div>
            <p>Your referral link:</p>
            <p style={{ wordBreak: "break-all", fontSize: "12px", marginTop: "4px" }}>
              {referralLink}
            </p>
          </div>,
          { autoClose: false }
        );
      }
    } catch (error) {
      console.error("Referral error:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  // Improved clipboard function with async/await
  const copyToClipboard = async (text) => {
    // Try modern clipboard API first
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (e) {
        console.error("Clipboard API failed:", e);
      }
    }

    // Fallback for iOS Safari and older browsers
    return fallbackCopyText(text);
  };

  const fallbackCopyText = (text) => {
    // Create a temporary input element
    const input = document.createElement("input");
    input.setAttribute("readonly", "readonly");
    input.setAttribute("contenteditable", "true");
    input.style.position = "fixed";
    input.style.left = "-9999px";
    input.style.top = "0";
    input.value = text;

    document.body.appendChild(input);

    let success = false;

    // Check if iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    if (isIOS) {
      // iOS specific handling
      const range = document.createRange();
      range.selectNodeContents(input);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      input.setSelectionRange(0, text.length);
    } else {
      input.select();
    }

    try {
      success = document.execCommand("copy");
    } catch (err) {
      console.error("execCommand copy failed:", err);
      success = false;
    }

    document.body.removeChild(input);

    return success;
  };


  // Get vessel Data and check redirecting of delivery page on depends vessel exist or not
  const handleDeliveryClick = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await HTTPSCalls.GET(
        `${apiUrl}${HTTPSCalls.EndPoints.GET_VESSEL_USERID}?`,
        { user_id: user?.id },
        { Authorization: `Bearer ${token}` }
      );
      const vesselsData = response.data;
      if (vesselsData?.length > 0) {
        navigate("/delivery"); // If vessels exist, navigate to the delivery page
      } else {
        (await getSwal()).fire({
          title: t('header.swal.noVessels.title', 'No vessels found'),
          text: t('header.swal.noVessels.text', 'Please add a vessel before booking a delivery request.'),
          icon: "warning", // Warning icon
          confirmButtonText: t('header.swal.ok', 'OK'),
          confirmButtonColor: "rgb(10 66 92)", // Custom button color
        });
      }
    } catch (error) {
      console.error("Error fetching vessels:", error);
      (await getSwal()).fire({
        title: t('header.swal.error.title', 'Error'),
        text: t('header.swal.error.text', 'Something went wrong while fetching vessel data. Please try again.'),
        icon: "error", // Error icon
        confirmButtonText: t('header.swal.ok', 'OK'),
        confirmButtonColor: "rgb(10 66 92)", // Custom button color
      });
    }
  };

  // For header dropdown
  const [showDropdown, setShowDropdown] = useState(false);
  // showQuotes is provided by DeliveryRequestsContext so Header updates automatically when deliveries change
  const { showQuotes } = useContext(DeliveryRequestsContext);
  // const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);
  const dropdownSearchRef = useRef(null);
  const handleRedirect = (type) => {
    setShowDropdown(false);
    if (type === "jobs") {
      navigate("/delivery-quotes");
    } else if (type === "posts") {
      navigate("/portfolio");
    } else if (type === "crew") {
      navigate("/crew");
    } else if (type === "findfriends") {
      navigate("/find-friends");
    }
  };
  const debounceRef = useRef(null);
  const blurTimeoutRef = useRef(null);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    // Clear the previous debounce timer
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    setShowAll(false); // Reset showAll when typing
    setShowDropdown(value.trim().length > 0);

    // Reset search results if input is empty
    if (value.trim().length === 0) {
      setSearchResults([]);
      return;
    }

    // Set a new debounce timer
    debounceRef.current = setTimeout(() => {
      performSearch(value, false);
    }, 500); // 500ms debounce delay
  };

  const handleShowAllClick = () => {
    setShowAll(true);
    performSearch(searchQuery, true);
  };

  // DeliveryRequestsContext handles fetching and keeps showQuotes in sync

  const performSearch = async (value, showAllType = false) => {
    if (value.trim().length === 0) {
      setSearchResults([]);
      return;
    }

    setSearchLoading(true);
    try {
      const token = localStorage.getItem("token");
      const body = showAllType
        ? { query: value, type: "see_all" }
        : { query: value };
      const response = await fetch(`${apiUrl}/user/search/common`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      // console.log('--- Search Results ---', `URL: ${apiUrl}/user/search/common`, 'Body:', body, 'Response:', data);
      if (data.success) {
        setSearchResults(data.data);
      } else {
        setSearchResults([]);
      }
    } catch (err) {
      setSearchResults([]);
    }
    setSearchLoading(false);
  };


  // const deliveryCount = user?.skipper_deliveries?.length || 0;
  const notificationCount = unreadCount;
  //const notificationCount = 5;
  // console.log("showQuotes", showQuotes);

  // console.log(user, "changesinuser");

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-blue main_header" style={{ zIndex: 1030 }} onClick={handleHeaderClick}>
        <div className="container-fluid header-section-1">
          <span className="header-section-1-1 navbar-brand me-md-0">
            {location.pathname !== "/login" &&
              location.pathname !== "/signup"
              && location.pathname !== "/account-deletion-guide" && location.pathname !== "/contact-support"
              && location.pathname !== "/welcome"
              ? (
                <>
                  <span
                    className="ff-altis site-text-logo text-white align-items-center cursor-pointer logov"
                    onClick={() => navigate("/portfolio")}
                  >
                    <img
                      className="logo me-2"
                      src="/media/anchor.svg"
                      alt={t('header.brand.alt', 'Vesseli Logo')}
                      title={t('header.brand.title', 'Vesseli Logo')}
                    />
                    VESSELI
                  </span>

                  <Link to="/personal-information" className="mobile-header-dp-link">
                    <img
                      src={
                        user && user.profile_picture
                          ? `${process.env.REACT_APP_LARAVEL_DOMAIN_URL}/${user.profile_picture}`
                          : "/media/display-picture.png"
                      }
                      onError={(e) => { e.target.onerror = null; e.target.src = PERSON_PLACEHOLDER; }}
                      alt={
                        user
                          ? t('header.profile.alt.userProfile', { defaultValue: "{{name}}'s Profile", name: user.name })
                          : t('header.profile.alt.default', 'Default User Profile')
                      }
                      className="logo mobile-header-dp"
                    />
                  </Link>
                </>

              ) : (
                <>
                  <span className="ff-altis site-text-logo text-white d-md-flex d-lg-flex d-flex align-items-center">
                    <img
                      className="logo me-2"
                      src="/media/anchor.svg"
                      alt={t('header.brand.alt', 'Vesseli Logo')}
                      title={t('header.brand.title', 'Vesseli Logo')}
                    />
                    VESSELI
                  </span>
                </>
              )}
          </span>

          {location.pathname !== "/login" &&
            location.pathname !== "/signup" &&
            location.pathname !== "/payment-success" &&
            location.pathname !== "/payment-cancel" &&
            location.pathname !== "/account-deletion-guide"

            && location.pathname !== "/contact-support"
            && location.pathname !== "/welcome" &&
            (
              <>
                {/* <div className="header-section-1-2 searchBox flex-grow-1 position-relative">
                  <input type='text' className='w-100 search-input pl-4' placeholder='Search' />
                  <span className="bi bi-search position-absolute search-icon"></span>
                </div> */}
                <div className="header-section-1-2 searchBox flex-grow-1 position-relative">
                  <input
                    type="text"
                    className="w-100 search-input pl-4"
                    placeholder={t('header.search.placeholder', 'Search')}
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onClick={() => setShowDropdown(true)}
                    onFocus={() => {
                      if (blurTimeoutRef.current) {
                        clearTimeout(blurTimeoutRef.current);
                        blurTimeoutRef.current = null;
                      }
                      setShowDropdown(true);
                    }}
                    onBlur={(e) => {
                      blurTimeoutRef.current = setTimeout(() => {
                        const next = e.relatedTarget;
                        const dropdownEl = dropdownSearchRef.current;
                        if (next && dropdownEl && dropdownEl.contains(next)) return;
                        setShowDropdown(false);
                      }, 150);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        const value = e.currentTarget.value;
                        if (value.trim().length > 0) {
                          if (debounceRef.current) {
                            clearTimeout(debounceRef.current);
                          }
                          setShowDropdown(true);
                          performSearch(value, false);
                        }
                      }
                    }}
                  />
                  <span className="bi bi-search position-absolute search-icon"></span>

                  {showDropdown && (
                    <div
                      className="dropdown-search-box position-absolute bg-white shadow p-3 rounded"
                      ref={dropdownSearchRef}
                      onMouseDown={(e) => e.preventDefault()}
                      style={{
                        top: "40px",
                        width: "100%",
                        zIndex: 9999,
                        maxHeight: "350px", // Set max height for scroll
                        overflowY: "auto",  // Enable vertical scroll
                      }}
                    >
                      <div className="d-flex flex-wrap gap-1 gap-md-2 mb-2">
                        {(user?.role == 3 || user?.role == 4) && (<button
                          className="btn btn-outline-primary btn-sm flex-fill flex-md-grow-0"
                          onClick={() => handleRedirect("jobs")}
                        >
                          {t('header.search.tabs.jobs', 'Jobs')}
                        </button>)}
                        {(user?.role === 1 || user?.role === 2) && showQuotes && (<button
                          className="btn btn-outline-primary btn-sm flex-fill flex-md-grow-0"
                          onClick={() => handleRedirect("jobs")}
                        >
                          {t('header.nav.quotes', 'Quotes')}
                        </button>)}

                        <button
                          className="btn btn-outline-success btn-sm flex-fill flex-md-grow-0"
                          onClick={() => handleRedirect("posts")}
                        >
                          {t('header.search.tabs.posts', 'Posts')}
                        </button>
                        <button
                          className="nav_all_btns btn btn-sm flex-fill flex-md-grow-0"
                          onClick={() => handleRedirect("crew")}
                        >
                          {t('header.search.searchCrew', 'Search Crew')}
                        </button>
                        <button
                          className="btn btn-outline-warning btn-sm flex-fill flex-md-grow-0"
                          onClick={() => handleRedirect("findfriends")}
                        >
                          <span className="d-none d-sm-inline">{t('header.search.tabs.findFriends', 'Find Friends ')}</span>
                          <span className="d-sm-none">{t('header.search.tabs.friends', 'Friends')}</span>
                        </button>
                      </div>
                      <p className="mb-0 text-muted" style={{ display: searchQuery ? "none" : "block" }}>
                        {t('header.search.typeToSearch', 'Type to search...')}
                      </p>
                      {searchLoading && (
                        <div className="mt-2 text-center text-muted">{t('header.search.searching', 'Searching...')}</div>
                      )}
                      {searchQuery && searchResults.length > 0 && (
                        <div className="mt-2">
                          {/* If hashtag search, render hashtags, else render users */}
                          {Array.isArray(searchResults) && searchResults[0]?.tag ? (
                            searchResults.map((hashtag) => (
                              <div
                                key={hashtag.id}
                                className="d-flex align-items-center mb-2 cursor-pointer"
                                onClick={() => navigate(`/hashtag/${hashtag.id}`)}
                              >
                                <span style={{ fontWeight: 500, color: "#007bff", marginRight: "10px" }}>
                                  {hashtag.tag}
                                </span>
                                <span className="text-muted" style={{ fontSize: "0.85em" }}>
                                  {hashtag.total_posts} {t('header.search.hashtag.postsSuffix', 'posts')}
                                </span>
                              </div>
                            ))
                          ) : (
                            searchResults
                              .slice()
                              .sort((a, b) => {
                                if (a.is_premium === b.is_premium) return 0;
                                return b.is_premium - a.is_premium;
                              })
                              .map((user) => {
                                let location = "";
                                try {
                                  location = JSON.parse(user.location)?.address || "";
                                } catch {
                                  location = "";
                                }
                                return (
                                  <div
                                    onMouseDown={(e) => {
                                      e.preventDefault();
                                      navigate("/personal-information", { state: { personId: user.id } });
                                      setSearchQuery('');
                                      setSearchResults([]);
                                      setShowDropdown(false);
                                    }}
                                    key={user.id} className="d-flex align-items-center mb-2 cursor-pointer" style={{ position: "relative" }}>
                                    <div style={{ position: "relative", width: 32, height: 32, marginRight: "10px" }}>
                                      <img
                                        src={
                                          user.profile_picture
                                            ? `${process.env.REACT_APP_LARAVEL_DOMAIN_URL}/${user.profile_picture}`
                                            : "/media/display-picture.png"
                                        }
                                        onError={(e) => { e.target.onerror = null; e.target.src = PERSON_PLACEHOLDER; }}
                                        alt={user.name}
                                        className="rounded-circle"
                                        width="32"
                                        height="32"
                                        style={{ objectFit: "cover" }}
                                      />
                                      {user.is_premium === 1 && (
                                        <img
                                          src="/media/premium-badge.svg"
                                          alt={t('header.premiumBadgeAlt', 'premium-badge')}
                                          style={{
                                            position: "absolute",
                                            bottom: -2,
                                            right: -2,
                                            width: 16,
                                            height: 16,
                                            zIndex: 2,
                                          }}
                                        />
                                      )}
                                    </div>
                                    <div>
                                      <div style={{ fontWeight: 500 }}>{user.name}</div>
                                      <div className="text-muted" style={{ fontSize: "0.85em" }}>
                                        {location}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                          )}
                          {searchQuery && !showAll && (
                            <div className="text-center">
                              <button
                                className="btn btn-link btn-sm mt-2"
                                style={{ textDecoration: "underline" }}
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={handleShowAllClick}
                              >
                                {t('header.search.showAll', 'Show All')}
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                      {searchQuery && !searchLoading && searchResults.length === 0 && (
                        <div className="mt-2 text-center text-muted">{t('header.search.noResults', 'No results found.')}</div>
                      )}
                    </div>
                  )}
                </div>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNav"
                  aria-controls="navbarNav"
                  onClick={closePanels}
                  aria-expanded={isNavbarExpanded}
                  aria-label="Toggle navigation"
                >
                  {/* <span
                    className="navbar-toggler-icon"
                    style={{
                      backgroundImage: "url('/media/navbar-toggler.svg')",
                    }}
                  ></span> */}
                  <span className="navbar-toggler-icon fa-solid fa-bars"></span>
                </button>
                <div
                  className="header-section-1-3 collapse navbar-collapse"
                  id="navbarNav"

                >
                  <ul className="navbar-nav ms-auto" >
                    <>
                      <li className="nav-item d-none d-lg-flex">
                        <Link
                          className={`nav-link d-flex flex-column align-items-center justify-content-center text-white ${isActive(
                            "/portfolio"
                          )}`}
                          to="/portfolio"
                        >
                          <svg
                            width="28"
                            height="28"
                            viewBox="0 0 56 56"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.3665 48.4666V41.3109C21.3665 39.4908 22.8503 38.0119 24.6887 37.9997H31.4229C33.2701 37.9997 34.7675 39.4821 34.7675 41.3109V48.4888C34.7671 50.0341 36.0129 51.2971 37.5734 51.3333H42.0629C46.5383 51.3333 50.1663 47.7415 50.1663 43.3109V22.9549C50.1424 21.2119 49.3158 19.5751 47.9216 18.5104L32.5677 6.26566C29.8779 4.13361 26.0542 4.13361 23.3643 6.26566L8.07773 18.5326C6.67828 19.593 5.85024 21.2325 5.83301 22.9771V43.3109C5.83301 47.7415 9.46105 51.3333 13.9365 51.3333H18.4259C20.0252 51.3333 21.3216 50.0498 21.3216 48.4666"
                              stroke="#ffffff"
                              strokeWidth="3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          {t('header.nav.home', 'Home')}
                        </Link>
                      </li>


                      {/* Refer a Friend (mobile) */}
                      <li
                        className="nav-item d-lg-none marineDasboard"
                        onClick={handleInvite}
                      >
                        <Link
                          className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                          to="#"
                        >
                          <FaRegCopy size={28} />{" "}
                          {/* {t('header.nav.exploreService', 'Explore Service')} */}
                          {t('header.menu.refer', 'Refer')}
                        </Link>
                      </li>

                      {/* Profile (mobile) */}
                      <li
                        className="nav-item d-lg-none marineDasboard"
                        onClick={() => { navigate("/personal-information") }}
                      >
                        <Link
                          className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                          to="#"
                        >
                          <IoPersonOutline size={28} />{" "}
                          {/* {t('header.nav.exploreService', 'Explore Service')} */}
                          {t('header.menu.profile', 'Profile')}
                        </Link>
                      </li>

                      {/* Subscription / Upgrade (mobile) */}
                      {user?.is_premium == 0 && (subscriptionToggle === 0 || subscriptionToggle === false) && (
                        <li
                          className="nav-item d-lg-none marineDasboard"
                          style={{ cursor: user?.profileStatus === 0 ? "not-allowed" : "pointer" }}
                          onClick={async () => {
                            if (user?.profileStatus === 0) {
                              if (!(user?.fname && user?.lname && user?.phone)) {
                                (await getSwal()).fire({
                                  icon: "warning",
                                  text: t("premiumPlan.completeProfileFirst"),
                                  confirmButtonText: t("common.ok"),
                                  confirmButtonColor: '#0C5272'
                                });
                              }
                              navigate("/profile");
                            } else {
                              navigate("/profile", { state: { step: "subscription" } });
                            }
                          }}
                        >
                          <Link
                            className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                            to="#"
                          >
                            <CiStar size={28} />{" "}
                            <span className="">
                              {t('header.menu.subscription', 'Subscription')}
                            </span>
                          </Link>
                        </li>
                      )}

                      {location.pathname === "/portfolio" && (
                        <>
                          <li
                            className="nav-item d-lg-none maintenanceSchedule"
                            onClick={handleMaintenanceScheduleClick}
                          >
                            {user?.role === 2 && user?.vesselsCount > 0 || user?.role === 3 && user?.vesselsCount > 0 ? (
                              <Link
                                className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                                to="#"
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M8.11173 8.80834L8.79506 8.09834L6.3609 5.665L6.28006 5.55167L5.13423 3.18667L3.03757 2.17084L2.1709 3.0375L3.2034 5.15L5.55006 6.28L5.66423 6.36084L8.11173 8.80834ZM12.5301 10.5483L10.5301 12.5125L15.7051 17.6875C15.7832 17.7656 15.8892 17.8095 15.9996 17.8095C16.1101 17.8095 16.2161 17.7656 16.2942 17.6875L17.6867 16.2942C17.7648 16.216 17.8087 16.1101 17.8087 15.9996C17.8087 15.8891 17.7648 15.7831 17.6867 15.705L12.5301 10.5483Z"
                                    stroke="white"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.02843 15.465C1.87027 14.8746 1.87041 14.253 2.02884 13.6627C2.18728 13.0725 2.49841 12.5343 2.93093 12.1025C3.36293 11.67 3.90121 11.3589 4.49163 11.2004C5.08204 11.042 5.70377 11.0418 6.29427 11.2L11.5401 5.95417C11.3817 5.36376 11.3816 4.74203 11.5399 4.15158C11.6982 3.56114 12.0092 3.02282 12.4418 2.59083C12.8739 2.15875 13.4121 1.84802 14.0023 1.68989C14.5926 1.53176 15.214 1.5318 15.8043 1.69L14.3134 3.18L14.2593 5.63L16.6876 5.555L18.2268 4.01667C18.4126 4.61151 18.4352 5.24533 18.2924 5.85193C18.1496 6.45852 17.8465 7.01563 17.4147 7.46506C16.983 7.91448 16.4385 8.23974 15.8382 8.40684C15.2378 8.57394 14.6036 8.57676 14.0018 8.415L8.75427 13.6625C8.91602 14.2643 8.9132 14.8985 8.7461 15.4989C8.579 16.0993 8.25375 16.6438 7.80432 17.0755C7.3549 17.5072 6.79779 17.8103 6.19119 17.9531C5.5846 18.096 4.95077 18.0733 4.35593 17.8875L5.8951 16.3483L5.9701 13.92L3.5201 13.9742L2.02843 15.465Z"
                                    stroke="white"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>{" "}
                                <span className="ms-2">Boat Maintenance Schedule</span>
                              </Link>
                            ) : (
                              <Link
                                className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                                to="#"
                              >
                                <i className="bi bi-person-fill-add" style={{ fontSize: 20 }} aria-hidden="true"></i>
                                <span className="ms-2">{t('rightPanel.people.mayKnow', 'People you may know')}</span>
                              </Link>
                            )}
                          </li>

                          <li
                            className="nav-item d-lg-none marineDasboard"
                            onClick={handleMarineDashboardClick}
                          >
                            <Link
                              className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                              to="#"
                            >
                              <TiWeatherPartlySunny size={28} />{" "}
                              {/* {t('header.nav.exploreService', 'Explore Service')} */}
                              {t('leftPanel.weather.title', 'Weather')}
                            </Link>
                          </li>
                        </>
                      )}


                      {(user?.role === 1 || user?.role === 2) && (
                        <li className="nav-item">
                          <Link
                            // onClick={handleDeliveryClick}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault(); // stop default <Link> behavior
                              handleDeliveryClick();
                            }}
                            className={`nav-link d-flex flex-column align-items-center justify-content-center text-white ${isActive(
                              "/delivery"
                            )}`}
                          >
                            <svg
                              width="28"
                              height="28"
                              viewBox="0 0 100 100"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M21 32C9.459 32 0 41.43 0 52.94c0 4.46 1.424 8.605 3.835 12.012l14.603 25.244c2.045 2.672 3.405 2.165 5.106-.14l16.106-27.41c.325-.59.58-1.216.803-1.856A20.668 20.668 0 0 0 42 52.94C42 41.43 32.544 32 21 32zm0 9.812c6.216 0 11.16 4.931 11.16 11.129c0 6.198-4.944 11.127-11.16 11.127c-6.215 0-11.16-4.93-11.16-11.127c0-6.198 4.945-11.129 11.16-11.129z"
                                fill="#fff"
                              ></path>
                              <path
                                d="M87.75 0C81.018 0 75.5 5.501 75.5 12.216c0 2.601.83 5.019 2.237 7.006l8.519 14.726c1.193 1.558 1.986 1.262 2.978-.082l9.395-15.99c.19-.343.339-.708.468-1.082a12.05 12.05 0 0 0 .903-4.578C100 5.5 94.484 0 87.75 0zm0 5.724c3.626 0 6.51 2.876 6.51 6.492c0 3.615-2.884 6.49-6.51 6.49c-3.625 0-6.51-2.875-6.51-6.49c0-3.616 2.885-6.492 6.51-6.492z"
                                fill="#fff"
                              ></path>
                              <path
                                d="M88.209 37.412c-2.247.05-4.5.145-6.757.312l.348 5.532a126.32 126.32 0 0 1 6.513-.303zm-11.975.82c-3.47.431-6.97 1.045-10.43 2.032l1.303 5.361c3.144-.896 6.402-1.475 9.711-1.886zM60.623 42.12a24.52 24.52 0 0 0-3.004 1.583l-.004.005l-.006.002c-1.375.866-2.824 1.965-4.007 3.562c-.857 1.157-1.558 2.62-1.722 4.35l5.095.565c.038-.406.246-.942.62-1.446h.002v-.002c.603-.816 1.507-1.557 2.582-2.235l.004-.002a19.64 19.64 0 0 1 2.388-1.256zM58 54.655l-3.303 4.235c.783.716 1.604 1.266 2.397 1.726l.01.005l.01.006c2.632 1.497 5.346 2.342 7.862 3.144l1.446-5.318c-2.515-.802-4.886-1.576-6.918-2.73c-.582-.338-1.092-.691-1.504-1.068zm13.335 5.294l-1.412 5.327l.668.208l.82.262c2.714.883 5.314 1.826 7.638 3.131l2.358-4.92c-2.81-1.579-5.727-2.611-8.538-3.525l-.008-.002l-.842-.269zm14.867 7.7l-3.623 3.92c.856.927 1.497 2.042 1.809 3.194l.002.006l.002.009c.372 1.345.373 2.927.082 4.525l5.024 1.072c.41-2.256.476-4.733-.198-7.178c-.587-2.162-1.707-4.04-3.098-5.548zM82.72 82.643a11.84 11.84 0 0 1-1.826 1.572h-.002c-1.8 1.266-3.888 2.22-6.106 3.04l1.654 5.244c2.426-.897 4.917-1.997 7.245-3.635l.006-.005l.003-.002a16.95 16.95 0 0 0 2.639-2.287zm-12.64 6.089c-3.213.864-6.497 1.522-9.821 2.08l.784 5.479c3.421-.575 6.856-1.262 10.27-2.18zm-14.822 2.836c-3.346.457-6.71.83-10.084 1.148l.442 5.522c3.426-.322 6.858-.701 10.285-1.17zm-15.155 1.583c-3.381.268-6.77.486-10.162.67l.256 5.536c3.425-.185 6.853-.406 10.28-.678zm-15.259.92c-2.033.095-4.071.173-6.114.245l.168 5.541a560.1 560.1 0 0 0 6.166-.246z"
                                fill="#fff"
                                fillRule="evenodd"
                              ></path>
                            </svg>{" "}
                            {t('header.nav.delivery', 'Delivery')}
                          </Link>
                        </li>
                      )}
                      {/* <li
                      className="nav-item"
                      onClick={handleDeliveryClick}
                      style={{ cursor: "pointer" }}
                    >
                      <div
                        className={`nav-link d-flex flex-column align-items-center justify-content-center text-white ${isActive('/delivery')}`}
                      >
                        <svg width="28" height="28" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                          <path d="M21 32C9.459 32 0 41.43 0 52.94c0 4.46 1.424 8.605 3.835 12.012l14.603 25.244c2.045 2.672 3.405 2.165 5.106-.14l16.106-27.41c.325-.59.58-1.216.803-1.856A20.668 20.668 0 0 0 42 52.94C42 41.43 32.544 32 21 32zm0 9.812c6.216 0 11.16 4.931 11.16 11.129c0 6.198-4.944 11.127-11.16 11.127c-6.215 0-11.16-4.93-11.16-11.127c0-6.198 4.945-11.129 11.16-11.129z" fill="#fff"></path><path d="M87.75 0C81.018 0 75.5 5.501 75.5 12.216c0 2.601.83 5.019 2.237 7.006l8.519 14.726c1.193 1.558 1.986 1.262 2.978-.082l9.395-15.99c.19-.343.339-.708.468-1.082a12.05 12.05 0 0 0 .903-4.578C100 5.5 94.484 0 87.75 0zm0 5.724c3.626 0 6.51 2.876 6.51 6.492c0 3.615-2.884 6.49-6.51 6.49c-3.625 0-6.51-2.875-6.51-6.49c0-3.616 2.885-6.492 6.51-6.492z" fill="#fff"></path><path d="M88.209 37.412c-2.247.05-4.5.145-6.757.312l.348 5.532a126.32 126.32 0 0 1 6.513-.303zm-11.975.82c-3.47.431-6.97 1.045-10.43 2.032l1.303 5.361c3.144-.896 6.402-1.475 9.711-1.886zM60.623 42.12a24.52 24.52 0 0 0-3.004 1.583l-.004.005l-.006.002c-1.375.866-2.824 1.965-4.007 3.562c-.857 1.157-1.558 2.62-1.722 4.35l5.095.565c.038-.406.246-.942.62-1.446h.002v-.002c.603-.816 1.507-1.557 2.582-2.235l.004-.002a19.64 19.64 0 0 1 2.388-1.256zM58 54.655l-3.303 4.235c.783.716 1.604 1.266 2.397 1.726l.01.005l.01.006c2.632 1.497 5.346 2.342 7.862 3.144l1.446-5.318c-2.515-.802-4.886-1.576-6.918-2.73c-.582-.338-1.092-.691-1.504-1.068zm13.335 5.294l-1.412 5.327l.668.208l.82.262c2.714.883 5.314 1.826 7.638 3.131l2.358-4.92c-2.81-1.579-5.727-2.611-8.538-3.525l-.008-.002l-.842-.269zm14.867 7.7l-3.623 3.92c.856.927 1.497 2.042 1.809 3.194l.002.006l.002.009c.372 1.345.373 2.927.082 4.525l5.024 1.072c.41-2.256.476-4.733-.198-7.178c-.587-2.162-1.707-4.04-3.098-5.548zM82.72 82.643a11.84 11.84 0 0 1-1.826 1.572h-.002c-1.8 1.266-3.888 2.22-6.106 3.04l1.654 5.244c2.426-.897 4.917-1.997 7.245-3.635l.006-.005l.003-.002a16.95 16.95 0 0 0 2.639-2.287zm-12.64 6.089c-3.213.864-6.497 1.522-9.821 2.08l.784 5.479c3.421-.575 6.856-1.262 10.27-2.18zm-14.822 2.836c-3.346.457-6.71.83-10.084 1.148l.442 5.522c3.426-.322 6.858-.701 10.285-1.17zm-15.155 1.583c-3.381.268-6.77.486-10.162.67l.256 5.536c3.425-.185 6.853-.406 10.28-.678zm-15.259.92c-2.033.095-4.071.173-6.114.245l.168 5.541a560.1 560.1 0 0 0 6.166-.246z" fill="#fff" fillRule="evenodd"></path>
                        </svg> Delivery
                      </div>
                    </li> */}

                      {user?.role == 3 || user?.role == 4 ? (

                        <>
                          <li className="nav-item d-none d-lg-flex">
                            <Link
                              className={`nav-link d-flex flex-column align-items-center justify-content-center text-white ${isActive(
                                "/delivery-quotes"
                              )}`}
                              to="/delivery-quotes"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="28"
                                height="28"
                                viewBox="0 0 52 52"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M23.8334 3.79166C22.0597 3.79187 20.3514 4.46139 19.05 5.66643C17.7485 6.87147 16.9498 8.52326 16.8134 10.2917H16.172C14.2134 10.2917 12.6339 10.2917 11.3577 10.4065C10.0447 10.5257 8.89635 10.7792 7.85419 11.3815C6.61887 12.0941 5.59289 13.1194 4.87935 14.3542C4.27919 15.3963 4.02569 16.5447 3.90652 17.8577C3.79169 19.1338 3.79169 20.7133 3.79169 22.672V22.828C3.79169 24.7867 3.79169 26.3662 3.90652 27.6423C4.02569 28.9553 4.27919 30.1037 4.88152 31.1458C5.42969 32.0992 6.16635 32.9268 7.04169 33.5833V33.7025C7.04169 36.6643 7.04169 39.0542 7.29519 40.9327C7.55519 42.8827 8.11852 44.525 9.42069 45.8293C10.725 47.1337 12.3674 47.6927 14.3174 47.957C16.1959 48.2083 18.5857 48.2083 21.5475 48.2083H30.4525C33.4144 48.2083 35.8042 48.2083 37.6827 47.957C39.6327 47.6927 41.275 47.1337 42.5794 45.8293C43.8837 44.525 44.4427 42.8827 44.707 40.9327C44.9584 39.0542 44.9584 36.6643 44.9584 33.7025V33.5833C45.8363 32.9252 46.5719 32.096 47.1207 31.1458C47.7209 30.1037 47.9744 28.9553 48.0935 27.6423C48.2084 26.3662 48.2084 24.7867 48.2084 22.828V22.672C48.2084 20.7133 48.2084 19.1338 48.0935 17.8577C47.9744 16.5447 47.7209 15.3963 47.1185 14.3542C46.4059 13.1189 45.3806 12.0929 44.1459 11.3793C43.1037 10.7792 41.9554 10.5257 40.6424 10.4065C39.3662 10.2917 37.7867 10.2917 35.828 10.2917H35.1867C35.0503 8.52326 34.2515 6.87147 32.9501 5.66643C31.6486 4.46139 29.9403 3.79187 28.1667 3.79166H23.8334ZM23.8334 7.04166C22.9216 7.04169 22.0404 7.37025 21.3512 7.96714C20.662 8.56402 20.2109 9.38927 20.0807 10.2917H31.9194C31.7891 9.38927 31.3381 8.56402 30.6488 7.96714C29.9596 7.37025 29.0784 7.04169 28.1667 7.04166H23.8334ZM10.5149 40.4993C10.3285 39.1148 10.2982 37.349 10.2917 34.957C10.6362 35.0155 10.9915 35.0588 11.3577 35.0935C12.6339 35.2083 14.2134 35.2083 16.172 35.2083H20.267C20.6211 36.4562 21.3726 37.5544 22.4075 38.3365C23.4423 39.1185 24.704 39.5416 26.0011 39.5416C27.2982 39.5416 28.5599 39.1185 29.5947 38.3365C30.6296 37.5544 31.3811 36.4562 31.7352 35.2083H35.828C37.7867 35.2083 39.3662 35.2083 40.6424 35.0935C41.0107 35.0588 41.3639 35.0155 41.7084 34.957C41.7019 37.349 41.6715 39.1148 41.4852 40.4993C41.2707 42.0897 40.8785 42.9303 40.2805 43.5305C39.6804 44.1307 38.8397 44.5207 37.2472 44.7352C35.6114 44.954 33.4425 44.9583 30.3334 44.9583H21.6667C18.5575 44.9583 16.3865 44.954 14.7507 44.7352C13.1604 44.5207 12.3197 44.1285 11.7195 43.5305C11.1194 42.9303 10.7294 42.0918 10.5149 40.4993ZM31.7352 31.9583H35.75C37.804 31.9583 39.2384 31.9583 40.3477 31.8565C41.4375 31.7568 42.055 31.5748 42.5209 31.3062C43.2619 30.8772 43.8772 30.2618 44.3062 29.5208C44.5749 29.055 44.7569 28.4375 44.8565 27.3477C44.9562 26.2383 44.9584 24.804 44.9584 22.75C44.9584 20.696 44.9584 19.2617 44.8565 18.1523C44.7569 17.0625 44.5749 16.445 44.3062 15.9792C43.8782 15.2376 43.2624 14.6218 42.5209 14.1938C42.055 13.9252 41.4375 13.7432 40.3477 13.6435C39.2384 13.5438 37.804 13.5417 35.75 13.5417H16.25C14.196 13.5417 12.7617 13.5417 11.6524 13.6435C10.5625 13.7432 9.94502 13.9252 9.47919 14.1938C8.73762 14.6218 8.12186 15.2376 7.69385 15.9792C7.42519 16.445 7.24319 17.0625 7.14352 18.1523C7.04385 19.2617 7.04169 20.696 7.04169 22.75C7.04169 24.804 7.04169 26.2383 7.14352 27.3477C7.24319 28.4353 7.42519 29.055 7.69385 29.5208C8.12285 30.2618 8.73819 30.8772 9.47919 31.3062C9.94502 31.5748 10.5625 31.7568 11.6524 31.8565C12.7617 31.9562 14.196 31.9583 16.25 31.9583H20.267C20.6211 30.7105 21.3726 29.6122 22.4075 28.8302C23.4423 28.0482 24.704 27.6251 26.0011 27.6251C27.2982 27.6251 28.5599 28.0482 29.5947 28.8302C30.6296 29.6122 31.3811 30.7105 31.7352 31.9583ZM23.2917 33.5833C23.2917 32.865 23.577 32.1762 24.0849 31.6683C24.5929 31.1603 25.2817 30.875 26 30.875C26.7183 30.875 27.4072 31.1603 27.9151 31.6683C28.423 32.1762 28.7084 32.865 28.7084 33.5833C28.7084 34.3016 28.423 34.9905 27.9151 35.4984C27.4072 36.0063 26.7183 36.2917 26 36.2917C25.2817 36.2917 24.5929 36.0063 24.0849 35.4984C23.577 34.9905 23.2917 34.3016 23.2917 33.5833Z"
                                  fill="white"
                                />
                              </svg>{" "}
                              {t('header.nav.jobs', 'Jobs')}
                            </Link>
                          </li>
                        </>

                      ) : null}

                      {(user?.role === 1 || user?.role === 2 || user?.role === 3) ? (
                        <>
                          {/*delivery-qoutes*/}
                          <li className="nav-item">
                            <Link
                              className={`nav-link d-flex flex-column align-items-center justify-content-center text-white ${isActive(
                                "/crew"
                              )}`}
                              to="/crew"
                            >
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 56 56"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M50.3982 38.6533C50.3982 33.9374 46.5622 30.1014 41.847 30.1014L34.3458 30.1028L27.9751 37.695L21.3314 30.1028L14.1508 30.1014C9.43561 30.1014 5.59961 33.9374 5.59961 38.654L5.60101 52.5H50.3996L50.3982 38.6533ZM8.40101 49.7L8.39961 38.6533C8.39961 35.4823 10.9798 32.9014 14.1508 32.9014L20.0609 32.9028L28.0185 41.9972L35.652 32.9028L41.847 32.9014C45.018 32.9014 47.5982 35.4816 47.5982 38.6533L47.5996 49.7H8.40101Z"
                                  fill="#fff"
                                  stroke="white"
                                />
                                <path
                                  d="M35.4357 41.2993H44.0996V44.0993H35.4357V41.2993ZM27.9996 3.5C21.4378 3.5 16.0996 9.3093 16.0996 16.45C16.0996 23.5907 21.4378 29.4 27.9996 29.4C34.5614 29.4 39.8996 23.5907 39.8996 16.45C39.8996 9.3093 34.5614 3.5 27.9996 3.5ZM27.9996 26.6C22.982 26.6 18.8996 22.0465 18.8996 16.45C18.8996 10.8535 22.982 6.3 27.9996 6.3C33.0172 6.3 37.0996 10.8535 37.0996 16.45C37.0996 22.0465 33.0172 26.6 27.9996 26.6Z"
                                  fill="#fff"
                                  stroke="white"
                                />
                              </svg>{" "}
                              {t('header.nav.findCrew', 'Find Crew')}
                            </Link>
                          </li>
                        </>
                      ) : null}

                      {user?.role === 1 || user?.role === 2 ? (
                        <>
                          {showQuotes && (
                            <li className="nav-item d-none d-lg-flex">
                              <Link
                                className={`nav-link d-flex flex-column align-items-center justify-content-center text-white ${isActive(
                                  "/delivery-quotes"
                                )}`}
                                to="/delivery-quotes"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="28"
                                  height="28"
                                  viewBox="0 0 52 52"
                                  fill="none"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M23.8334 3.79166C22.0597 3.79187 20.3514 4.46139 19.05 5.66643C17.7485 6.87147 16.9498 8.52326 16.8134 10.2917H16.172C14.2134 10.2917 12.6339 10.2917 11.3577 10.4065C10.0447 10.5257 8.89635 10.7792 7.85419 11.3815C6.61887 12.0941 5.59289 13.1194 4.87935 14.3542C4.27919 15.3963 4.02569 16.5447 3.90652 17.8577C3.79169 19.1338 3.79169 20.7133 3.79169 22.672V22.828C3.79169 24.7867 3.79169 26.3662 3.90652 27.6423C4.02569 28.9553 4.27919 30.1037 4.88152 31.1458C5.42969 32.0992 6.16635 32.9268 7.04169 33.5833V33.7025C7.04169 36.6643 7.04169 39.0542 7.29519 40.9327C7.55519 42.8827 8.11852 44.525 9.42069 45.8293C10.725 47.1337 12.3674 47.6927 14.3174 47.957C16.1959 48.2083 18.5857 48.2083 21.5475 48.2083H30.4525C33.4144 48.2083 35.8042 48.2083 37.6827 47.957C39.6327 47.6927 41.275 47.1337 42.5794 45.8293C43.8837 44.525 44.4427 42.8827 44.707 40.9327C44.9584 39.0542 44.9584 36.6643 44.9584 33.7025V33.5833C45.8363 32.9252 46.5719 32.096 47.1207 31.1458C47.7209 30.1037 47.9744 28.9553 48.0935 27.6423C48.2084 26.3662 48.2084 24.7867 48.2084 22.828V22.672C48.2084 20.7133 48.2084 19.1338 48.0935 17.8577C47.9744 16.5447 47.7209 15.3963 47.1185 14.3542C46.4059 13.1189 45.3806 12.0929 44.1459 11.3793C43.1037 10.7792 41.9554 10.5257 40.6424 10.4065C39.3662 10.2917 37.7867 10.2917 35.828 10.2917H35.1867C35.0503 8.52326 34.2515 6.87147 32.9501 5.66643C31.6486 4.46139 29.9403 3.79187 28.1667 3.79166H23.8334ZM23.8334 7.04166C22.9216 7.04169 22.0404 7.37025 21.3512 7.96714C20.662 8.56402 20.2109 9.38927 20.0807 10.2917H31.9194C31.7891 9.38927 31.3381 8.56402 30.6488 7.96714C29.9596 7.37025 29.0784 7.04169 28.1667 7.04166H23.8334ZM10.5149 40.4993C10.3285 39.1148 10.2982 37.349 10.2917 34.957C10.6362 35.0155 10.9915 35.0588 11.3577 35.0935C12.6339 35.2083 14.2134 35.2083 16.172 35.2083H20.267C20.6211 36.4562 21.3726 37.5544 22.4075 38.3365C23.4423 39.1185 24.704 39.5416 26.0011 39.5416C27.2982 39.5416 28.5599 39.1185 29.5947 38.3365C30.6296 37.5544 31.3811 36.4562 31.7352 35.2083H35.828C37.7867 35.2083 39.3662 35.2083 40.6424 35.0935C41.0107 35.0588 41.3639 35.0155 41.7084 34.957C41.7019 37.349 41.6715 39.1148 41.4852 40.4993C41.2707 42.0897 40.8785 42.9303 40.2805 43.5305C39.6804 44.1307 38.8397 44.5207 37.2472 44.7352C35.6114 44.954 33.4425 44.9583 30.3334 44.9583H21.6667C18.5575 44.9583 16.3865 44.954 14.7507 44.7352C13.1604 44.5207 12.3197 44.1285 11.7195 43.5305C11.1194 42.9303 10.7294 42.0918 10.5149 40.4993ZM31.7352 31.9583H35.75C37.804 31.9583 39.2384 31.9583 40.3477 31.8565C41.4375 31.7568 42.055 31.5748 42.5209 31.3062C43.2619 30.8772 43.8772 30.2618 44.3062 29.5208C44.5749 29.055 44.7569 28.4375 44.8565 27.3477C44.9562 26.2383 44.9584 24.804 44.9584 22.75C44.9584 20.696 44.9584 19.2617 44.8565 18.1523C44.7569 17.0625 44.5749 16.445 44.3062 15.9792C43.8782 15.2376 43.2624 14.6218 42.5209 14.1938C42.055 13.9252 41.4375 13.7432 40.3477 13.6435C39.2384 13.5438 37.804 13.5417 35.75 13.5417H16.25C14.196 13.5417 12.7617 13.5417 11.6524 13.6435C10.5625 13.7432 9.94502 13.9252 9.47919 14.1938C8.73762 14.6218 8.12186 15.2376 7.69385 15.9792C7.42519 16.445 7.24319 17.0625 7.14352 18.1523C7.04385 19.2617 7.04169 20.696 7.04169 22.75C7.04169 24.804 7.04169 26.2383 7.14352 27.3477C7.24319 28.4353 7.42519 29.055 7.69385 29.5208C8.12285 30.2618 8.73819 30.8772 9.47919 31.3062C9.94502 31.5748 10.5625 31.7568 11.6524 31.8565C12.7617 31.9562 14.196 31.9583 16.25 31.9583H20.267C20.6211 30.7105 21.3726 29.6122 22.4075 28.8302C23.4423 28.0482 24.704 27.6251 26.0011 27.6251C27.2982 27.6251 28.5599 28.0482 29.5947 28.8302C30.6296 29.6122 31.3811 30.7105 31.7352 31.9583ZM23.2917 33.5833C23.2917 32.865 23.577 32.1762 24.0849 31.6683C24.5929 31.1603 25.2817 30.875 26 30.875C26.7183 30.875 27.4072 31.1603 27.9151 31.6683C28.423 32.1762 28.7084 32.865 28.7084 33.5833C28.7084 34.3016 28.423 34.9905 27.9151 35.4984C27.4072 36.0063 26.7183 36.2917 26 36.2917C25.2817 36.2917 24.5929 36.0063 24.0849 35.4984C23.577 34.9905 23.2917 34.3016 23.2917 33.5833Z"
                                    fill="white"
                                  />
                                </svg>
                                {t('header.nav.quotes', 'Quotes')}
                              </Link>
                            </li>)}
                        </>
                      ) : null}

                      <li className="nav-item d-none d-lg-flex" onClick={handleClick}>

                        <a className="nav-link d-flex flex-column align-items-center justify-content-center text-white" style={{ cursor: "pointer" }} href="#" onClick={(e) => e.preventDefault()}>
                          <div className="position-relative">
                            <GoBell size={28} color="white" />
                            {notificationCount > 0 && (
                              <span
                                className="position-absolute top-0 start-95 translate-middle badge rounded-pill bg-danger"
                                style={{ fontSize: "0.6rem" }}
                              >
                                {notificationCount}
                              </span>
                            )}
                          </div>
                          <span>
                            {t('header.nav.notification', 'Notification')}
                          </span>
                        </a>

                        {/* <Link className="nav-link d-flex flex-column align-items-center justify-content-center text-white">
                            <GoBell size={28} color="white" />
                            <span style={{ cursor: "pointer" }}>
                              {t('header.nav.notification', 'Notification')}
                            </span>
                          </Link> */}

                      </li>
                      <li className="nav-item d-none d-lg-flex">
                        <Link
                          // className={`nav-link d-flex flex-column align-items-center justify-content-center text-white me-link ${isActive(
                          //   "/personal-information"
                          // )}`}
                          className={`nav-link d-flex flex-column align-items-center justify-content-center text-white me-link ${isActive("/personal-information") ? "active" : ""}`}
                          to="/personal-information"
                        >
                          {user?.profile_picture ? (
                            <img
                              src={
                                user?.profile_picture
                                  ? `${process.env.REACT_APP_LARAVEL_DOMAIN_URL}/${user.profile_picture}`
                                  : "/media/profile_bg.png"
                              }
                              onError={(e) => { e.target.onerror = null; e.target.src = PERSON_PLACEHOLDER; }}
                              alt={t('header.profile.alt.profile', 'Profile')}
                              className="rounded-circle"
                              width="28"
                              height="28"
                              style={{ objectFit: "cover" }}
                            />
                          ) : (
                            <>
                              <svg
                                width="28"
                                height="28"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                <g
                                  id="SVGRepo_tracerCarrier"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <g id="SVGRepo_iconCarrier">
                                  <circle
                                    opacity="1"
                                    cx="12"
                                    cy="9"
                                    r="3"
                                    stroke="#ffffff"
                                    strokeWidth="1.5"
                                  />
                                  <circle
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="#ffffff"
                                    strokeWidth="1.5"
                                  />
                                  <path
                                    opacity="1"
                                    d="M17.9691 20C17.81 17.1085 16.9247 15 11.9999 15C7.07521 15 6.18991 17.1085 6.03076 20"
                                    stroke="#ffffff"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                  />
                                </g>
                              </svg>
                            </>
                          )}
                          {t('header.nav.me', 'Me')}
                        </Link>
                      </li>



                      {/* <li
                        className="nav-item d-lg-none marineDasboard"
                        onClick={() => { user?.vesselsCount > 0 ? navigate("/my-vessel") : navigate("/add-vessel") }}
                      >
                        <Link
                          className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                          to="#"
                        >
                          <SailboatIcon size={28} />{" "}
                        
                          {user?.vesselsCount > 0 ? t('leftPanel.nav.myVessel', 'My Vessel') : t('leftPanel.nav.addVessel', 'Add Vessel')}
                        </Link>
                      </li> */}

                      {location.pathname === "/my-vessel" && (
                        <>
                          <li
                            className="nav-item d-lg-none vesselSettings"
                            onClick={handleMVLeftPanelClick}
                          >
                            <Link
                              className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                              to="#"
                            >
                              <img
                                src="/media/navs/myVessel.png"
                                width="30"
                                style={{ padding: "2px 4px" }}
                              />{" "}
                              {t('header.nav.vesselSettings', 'Vessel Settings')}
                            </Link>
                          </li>
                          <li
                            className="nav-item d-lg-none exploreServices"
                            onClick={handleMVRightClick}
                          >
                            <Link
                              className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                              to="#"
                            >
                              <img
                                src="/media/navs/exploreServices.png"
                                width="30"
                              />{" "}
                              {t('header.nav.exploreServices', 'Explore Services')}
                            </Link>
                          </li>
                        </>
                      )}

                      {/* Settings: show a dropdown on large screens (>= 993px) and expose separate nav items only on small screens (< 993px) */}
                      {/* Desktop: dropdown (visible on lg and up) - match provided markup/style */}
                      <li className="nav-item dropdown caret-after d-none d-lg-flex">
                        <Link
                          ref={settingsToggleRef}
                          className="nav-link d-flex flex-column align-items-center justify-content-center text-white dropdown-toggle"
                          to="#"
                          id="navbarDropdown"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <svg
                            width="28"
                            height="28"
                            viewBox="0 0 56 56"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M48.5493 17.7884L47.0969 15.2681C45.8683 13.1357 43.1454 12.4 41.01 13.6236C39.9935 14.2224 38.7806 14.3923 37.6387 14.0958C36.4968 13.7993 35.5198 13.0608 34.923 12.0431C34.5391 11.3963 34.3328 10.6595 34.325 9.90735C34.3597 8.70144 33.9047 7.53286 33.0638 6.66781C32.2229 5.80277 31.0677 5.31493 29.8612 5.31543H26.9352C25.7533 5.31543 24.6201 5.78639 23.7864 6.62412C22.9527 7.46186 22.4871 8.5973 22.4928 9.7792C22.4578 12.2194 20.4695 14.1791 18.0291 14.1789C17.2769 14.1711 16.5401 13.9648 15.8933 13.5809C13.7579 12.3573 11.035 13.0929 9.80633 15.2254L8.24722 17.7884C7.02003 19.9182 7.74567 22.6393 9.8704 23.8753C11.2515 24.6727 12.1023 26.1463 12.1023 27.7411C12.1023 29.3358 11.2515 30.8094 9.8704 31.6068C7.74837 32.8344 7.02194 35.549 8.24722 37.6724L9.7209 40.214C10.2966 41.2527 11.2625 42.0193 12.4049 42.3439C13.5472 42.6686 14.7719 42.5247 15.8079 41.944C16.8263 41.3497 18.0398 41.1869 19.1789 41.4917C20.3179 41.7965 21.288 42.5437 21.8735 43.5671C22.2574 44.214 22.4637 44.9508 22.4715 45.7029C22.4715 48.1682 24.47 50.1667 26.9352 50.1667H29.8612C32.3182 50.1667 34.3133 48.1812 34.325 45.7243C34.3193 44.5387 34.7878 43.4 35.6261 42.5616C36.4645 41.7233 37.6032 41.2548 38.7888 41.2605C39.5391 41.2806 40.2729 41.486 40.9246 41.8585C43.0544 43.0857 45.7755 42.3601 47.0115 40.2353L48.5493 37.6724C49.1445 36.6507 49.3079 35.4339 49.0032 34.2915C48.6985 33.149 47.951 32.1751 46.9261 31.5855C45.9012 30.9958 45.1536 30.0219 44.849 28.8795C44.5443 27.737 44.7077 26.5202 45.3029 25.4985C45.69 24.8227 46.2503 24.2624 46.9261 23.8753C49.0381 22.64 49.762 19.9347 48.5493 17.8097V17.7884Z"
                              stroke="white"
                              strokeWidth="3.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M28.4085 33.8917C31.8054 33.8917 34.5591 31.1379 34.5591 27.741C34.5591 24.3441 31.8054 21.5903 28.4085 21.5903C25.0116 21.5903 22.2578 24.3441 22.2578 27.741C22.2578 31.1379 25.0116 33.8917 28.4085 33.8917Z"
                              stroke="white"
                              strokeWidth="3.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>{" "}
                          <span className="text-break text-center">{t('header.menu.settings', 'Settings')}</span>
                        </Link>
                        {/* Mobile-only caret that triggers the settings link click (opens dropdown) */}
                        <button
                          type="button"
                          className="btn btn-link p-0 text-white ms-2 d-lg-none"
                          aria-label={t('header.menu.openSettings', 'Open settings')}
                          onClick={() => settingsToggleRef.current && settingsToggleRef.current.click()}
                          style={{ fontSize: '18px', lineHeight: 1 }}
                        >
                          {/* caret intentionally empty to rely on styling or icon if desired */}
                        </button>
                        <ul
                          className="dropdown-menu dropdown-menu-end"
                          aria-labelledby="navbarDropdown"
                        >
                          <li
                            className="dropdown-item cursor-pointer text-break d-flex align-items-center"
                            style={{ fontSize: "17px", fontWeight: 400 }}
                            onClick={() =>
                              navigate("/personal-information", {
                                state: { step: "personal-information" },
                              })
                            }
                          >
                            <i className="fa fa-user me-2" aria-hidden="true"></i>
                            {t('header.menu.profile', 'Profile')}
                          </li>
                          {user?.role === 2 || user?.role === 3 ? (
                            <li
                              className="dropdown-item cursor-pointer  text-break d-flex align-items-center text-wrap"
                              style={{ fontSize: "17px", fontWeight: 400 }}
                              onClick={() =>
                                navigate("/wallet")
                              }>
                              <i className="fa fa-wallet me-2" aria-hidden="true"></i>
                              {t('header.menu.ewallet', 'E-wallet')}
                            </li>
                          ) : null}
                          {user?.is_premium == 0 && (subscriptionToggle === 0 || subscriptionToggle === false) && (
                            <li
                              className="dropdown-item cursor-pointer text-break d-flex align-items-center"
                              style={{ fontSize: "17px", fontWeight: 400, cursor: user?.profileStatus === 0 ? "not-allowed" : "pointer" }}
                              onClick={async () => {
                                if (user?.profileStatus === 0) {
                                  if (!(user?.fname && user?.lname && user?.phone)) {
                                    (await getSwal()).fire({
                                      icon: "warning",
                                      text: t("premiumPlan.completeProfileFirst"),
                                      confirmButtonText: t("common.ok"),
                                      confirmButtonColor: '#0C5272'
                                    });
                                  }
                                  navigate("/profile");
                                } else {
                                  navigate("/profile", { state: { step: "subscription" } });
                                }
                              }}
                            >
                              <i className="fa fa-star me-2" aria-hidden="true"></i>
                              {t('header.menu.subscription', 'Subscription')}
                            </li>
                          )}


                          <li
                            className="dropdown-item cursor-pointer  text-break d-flex align-items-center"
                            style={{ fontSize: "17px", fontWeight: 400 }}
                            onClick={handleInvite}
                          >
                            <i className="fa fa-copy me-2" aria-hidden="true"></i>
                            {t("header.menu.refer", "Refer a Friend")}
                          </li>
                          <li
                            className="dropdown-item cursor-pointer text-break d-flex align-items-center"
                            style={{ fontSize: "17px", fontWeight: 400 }}
                            onClick={() => navigate("/profile")}
                          >
                            <i className="fa fa-cog me-2" aria-hidden="true"></i>
                            {t('header.menu.profileSettings', 'Profile Settings')}
                          </li>
                          <li
                            className="dropdown-item cursor-pointer  text-break d-flex align-items-center"
                            style={{ fontSize: "17px", fontWeight: 400 }}
                            onClick={() =>
                              navigate("/logout")
                            }>
                            <i className="fa fa-sign-out-alt me-2" aria-hidden="true"></i>
                            {t('header.menu.logout', 'Logout')}
                          </li>
                        </ul>
                      </li>

                      {/* Mobile / small screens: separate nav items (visible only below lg) */}
                      <>


                        {/* E-wallet (role-based, mobile) */}
                        {user?.role === 2 || user?.role === 3 ? (
                          <li
                            className="nav-item d-lg-none marineDasboard"
                            onClick={() => { navigate("/wallet") }}
                          >
                            <Link
                              className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                              to="#"
                            >
                              <MdOutlineAccountBalanceWallet size={28} />{" "}
                              {/* {t('header.nav.exploreService', 'Explore Service')} */}
                              {t('header.menu.ewallet', 'E-wallet')}
                            </Link>
                          </li>
                        ) : null}






                        {/* Profile Settings (mobile) */}
                        <li
                          className="nav-item d-lg-none marineDasboard"
                          onClick={() => { navigate("/profile") }}
                        >
                          <Link
                            className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                            to="#"
                          >
                            <FaCog size={28} />{" "}
                            {t('header.menu.profileSettings', 'Profile Settings')}
                          </Link>
                        </li>

                        {/* Logout (mobile) */}
                        <li
                          className="nav-item d-lg-none marineDasboard"
                          onClick={() => { navigate("/logout") }}
                        >
                          <Link
                            className="nav-link d-flex flex-column align-items-center justify-content-center text-white"
                            to="#"
                          >
                            <FaSignOutAlt size={28} />{" "}
                            {/* {t('header.nav.exploreService', 'Explore Service')} */}
                            {t('header.menu.logout', 'Logout')}
                          </Link>
                        </li>
                      </>
                    </>
                  </ul>
                </div>
              </>
            )}
        </div>
        {/* <div className="footer_main">
     <MobileFooter />
    </div> */}
        {show && (
          <NotificationPop
            show={show}
            target={target}
            setShow={setShow}
            liveNotification={liveNotification}
            setLiveNotification={setLiveNotification}
          />
        )}
      </nav>
    </>
  );
};

export default Header;